








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ContactChannelCheckbox extends Vue {
  @Prop() public value?: boolean;
  @Prop() public identifier: string;
  @Prop() public inputLabel: string;

  public get channelContact(): boolean {
    return this.value;
  }

  public set channelContact(value: boolean) {
    this.$emit('input', value);
  }
}
